export default __webpack_public_path__ + "static/media/partner11.0254816d.webp";